// OPEN ALL EXTERNAL LINKS IN NEW TAB
function targetBlank() {
    var internal = location.host.replace("www.", "");
    internal = new RegExp(internal, "i");
    var a = document.getElementsByTagName('a'); // grab every link on the page
    for (var i = 0; i < a.length; i++) {
        var href = a[i].host; // set the host of shopify link
        if( !internal.test(href) ) { // make sure the href of a element in loop doesn't contain current site's host
            a[i].setAttribute('target', '_blank'); // if it doesn't, set attribute
        }
    }
};
// Run the function targetBlank()
targetBlank();


// ADD PEAR LOGO TO ABOUT SECTION SCRIPT CALLOUT ON HOMEPAGE
// ONLY APPEARS ON LIVE SITE, NOT IN EDIT MODE!
document.addEventListener('DOMContentLoaded', function () {
    // Skip entirely when viewing inside the Shopify theme editor
    if (window.Shopify && window.Shopify.designMode) return;

    injectLogoImage();
  });

  function injectLogoImage() {
    var textEl = document.querySelector('.split-about .script-callout__text');
    if (!textEl) return;

    var original = textEl.textContent;
    var splitWord = 'logo'; // the word to inject the image after
    var index = original.indexOf(splitWord);
    if (index === -1) return; // bail if word not found, leaves text untouched

    var before = original.slice(0, index + splitWord.length); // "...our pear logo"
    var after = original.slice(index + splitWord.length);     // " is inspired..."

    // Check viewport — adjust breakpoint to match your theme's mobile breakpoint
    var isMobile = window.matchMedia('(max-width: 767px)').matches;

    var imgSettings = isMobile
      ? { width: 12, height: 18, margin: '0 3px' }
      : { width: 20, height: 29, margin: '0 6px' };

    var img = document.createElement('img');
    img.src = 'https://cdn.shopify.com/s/files/1/0736/9965/5917/files/Mimis-Needlepoint_pear-icon.svg?v=1783500309'; // image url
    img.width = imgSettings.width;
    img.height = imgSettings.height;
    img.alt = '';
    img.style.display = 'inline-block';
    img.style.verticalAlign = 'middle';
    img.style.margin = imgSettings.margin;

    textEl.textContent = '';
    textEl.appendChild(document.createTextNode(before));
    textEl.appendChild(img);
    textEl.appendChild(document.createTextNode(after));
}